export enum DimensionVariants {
  BYTES = 'Bytes',
  KB = 'KB',
  MB = 'MB',
}
